module.exports = __webpack_public_path__ + "static/media/tutorial4.08539607.png";